import { Icon } from '@tencent/udesign/dist';

export const renderIconDownRight = (isExpand: boolean) => {
  if (isExpand) {
    return <Icon icon="mdi-menu-down" />;
  }
  return <Icon icon="mdi-menu-right" />;
};
